import keyEventsRaw from "../Data/key_events.csv";
import keyTrendsRaw from "../Data/key_trends.csv";
import rawData from '../Data/events_data.csv'
import { csv } from "d3";
import { useEffect, useState } from "react";

const UseMonthConfig = () => {

  //Set trends & events
  const [keyEvents, setKeyEvents] = useState(null);
  const [keyTrends, setKeyTrends] = useState(null);
  const [data, setData] = useState();

  useEffect(() => {
    csv(keyEventsRaw).then(setKeyEvents);
    let trendsObj = [];
    csv(keyTrendsRaw).then((trendsArray) => {
      trendsArray.map((trendSingle, index) => {
      //return trendsObj[trendSingle.country_location] = 
      return trendsObj[index] = {
        countryLocation: trendSingle.country_location,
          countryTitle: trendSingle.country_display,
          slug: `#keytrend${trendSingle.para}`,
          content: trendSingle.content,
          icon: trendSingle.icon,
        };
      });
    });
    setKeyTrends(trendsObj);
    const row = (d) => {
        d.latitude = +d.latitude;
        d.longitude = +d.longitude
        d.latlng = [+d.latitude,+d.longitude]
        d.pv_count = +d.pv_count
        d.demo_count = +d.demo_count
        return d;
      };
      csv(rawData, row).then(d => setData(d));
  }, []);

  return {
    trendCountries: keyTrends,
    keyEvents: keyEvents,
    data: data
  };
};

export default UseMonthConfig;
